import * as z from "zod/v4";

const returnsCenterLocationSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const get3plDashboardMetrics = {
  name: "get3plDashboardMetrics" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
  }),
  output: z.object({
    // Returns KPIs
    incomingReturnsCount: z.number(),
    avgProcessingTimeDays: z.number().nullable(),
    totalReturnsProcessedCount: z.number(),
    processingTimeSampleCount: z.number(),
    processedWithin3DaysCount: z.number(),

    // Fulfillment KPIs
    inventoryItemCount: z.number(),
    avgFulfillmentTimeDays: z.number().nullable(),
    totalFulfillmentsCount: z.number(),
    ordersInRangeCount: z.number(),
    noonCutoffMetCount: z.number(),

    // Filter options
    returnsCenterLocations: z.array(returnsCenterLocationSchema),
  }),
};

export type ThreePlDashboardMetricsOutput = z.infer<
  (typeof get3plDashboardMetrics)["output"]
>;
